import fetch from 'utils/fetch'

export function getDatasetList (data) {
  return fetch({
    url: `${process.env.DATASET_SELECTOR_API}/dataset/selector/getDatasetList`,
    method: 'post',
    data
  })
}
export function getDatasetListCount (data) {
  return fetch({
    url: `${process.env.DATASET_SELECTOR_API}/dataset/selector/getDatasetListCount`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/datasetSelector.js